<template>
  <div class="container">
    <h1>Gestión de la cuenta</h1>
    <div>
      <h4>Cambio de ajustes</h4>
      <hr />
      <b-card no-body>
        <b-tabs pills card vertical>
          <b-tab title="Perfil" active>
            <h3>Cambiar Datos</h3>
            <div class="row">
              <div class="col-md-6">
                <form @submit.prevent="modificarProfile" id="profile-form">
                  <b-form-group label="Nombre de usuario">
                    <b-form-input
                      autofocus
                      required
                      maxlength="25"
                      type="text"
                      v-model="$v.form_profile.name.$model"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group label="Telefono de contacto">
                    <b-form-input
                      :state="!$v.form_profile.phone.$error"
                      maxlength="9"
                      type="text"
                      v-model="$v.form_profile.phone.$model"
                    >
                    </b-form-input>
                  </b-form-group>

                  <b-btn type="submit">Grabar</b-btn>
                  <b-btn class="m-2" @click.prevent="resetForm">Cancelar</b-btn>
                </form>
              </div>
            </div>
          </b-tab>
          <b-tab title="Password">
            <h3>Cambiar Password</h3>
            <div class="row">
              <div class="col-md-6">
                <form @submit.prevent="modificarPassword" id="password-form">
                  <b-form-group label="Password Actual">
                    <b-form-input
                      autofocus
                      placeholder="Escriba su password actual"
                      maxlength="20"
                      type="password"
                      :state="null"
                      v-model="$v.form_password.currentPassword.$model"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group label="Nuevo password">
                    <b-form-input
                      placeholder="Escriba su nuevo password"
                      :state="!$v.form_password.newPassword.$error"
                      maxlength="20"
                      type="password"
                      aria-describedby="newPassword-feedback"
                      v-model="$v.form_password.newPassword.$model"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback
                      v-if="!$v.form_password.newPassword.required"
                      id="newPassword-feedback"
                    >
                      Campo obligatorio.
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback
                      v-if="!$v.form_password.newPassword.minLength"
                      id="confirmPassword-feedback"
                    >
                      Longitud minima 6 caracteres
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="Confirmar nuevo password">
                    <b-form-input
                      placeholder="Confirme de nuevo el password"
                      :state="!$v.form_password.confirmNewPassword.$error"
                      aria-describedby="confirmPassword-feedback"
                      maxlength="20"
                      type="password"
                      v-model="$v.form_password.confirmNewPassword.$model"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback
                      v-if="!$v.form_password.confirmNewPassword.required"
                    >
                      Campo obligatorio.
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback
                      v-if="!$v.form_password.confirmNewPassword.minLength"
                    >
                      Longitud minima 6 caracteres
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback
                      v-if="!$v.form_password.confirmNewPassword.sameAsPassword"
                    >
                      El campo 'Nuevo password' y 'Confirmar nuevo password' no
                      son coincidentes
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-btn type="submit">Actualizar password</b-btn>
                  <b-btn class="m-2" @click.prevent="resetForm">Cancelar</b-btn>
                </form>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  sameAs
} from 'vuelidate/lib/validators'
import { authComputed } from '../../store/helpers.js'
import DataAccess from '@/Services/DataAccess.js'

export default {
  computed: {
    ...authComputed,
    nameState () {
      return this.form_password.confirmNewPassword == null ||
        this.form_password.confirmNewPassword === ''
        ? null
        : this.form_password.newPassword ===
            this.form_password.confirmNewPassword
    }
  },
  data () {
    return {
      form_profile: {
        name: null,
        phone: null
      },
      form_password: {
        currentPassword: null,
        newPassword: null,
        confirmNewPassword: null
      }
    }
  },
  validations: {
    form_profile: {
      name: {
        required,
        maxLength: maxLength(25)
      },
      phone: {
        maxLength: maxLength(9)
      }
    },
    form_password: {
      currentPassword: { required },
      newPassword: {
        required,
        minLength: minLength(6)
      },
      confirmNewPassword: {
        required,
        minLength: minLength(6),
        sameAsPassword: sameAs('newPassword')
      }
    }
  },
  created () {
    this.form_profile.name = this.$store.getters.loggedUserName
    this.form_profile.phone = this.$store.getters.loggedPhone
  },
  methods: {
    makeToast (toaster, variant, title, message, append = false) {
      this.$bvToast.toast(message, {
        toaster: toaster,
        title: title,
        variant: variant,
        solid: true,
        append: append
      })
    },
    modificarProfile () {
      DataAccess.putData(
        '/api/usuarios/UpdateUserProfile',
        {
          Email: this.$store.getters.loggedUserAccount,
          NombreUsuario: this.form_profile.name,
          TelefonoUsuario: this.form_profile.phone
        },
        {
          withCredentials: true
        }
      )
        .then(() => {
          this.$store.dispatch('actualizaTelefono', this.form_profile.phone)
        })
        .catch(error => {
          this.makeToast(
            'b-toaster-bottom-full',
            'danger',
            'Actualización de Perfil',
            'Errores en la actualización del perfil'
          )
          console.log('Error en la acutalizacion del perfil:', error.response)
        })
    },
    modificarPassword () {
      this.$store
        .dispatch('modifPassword', {
          Email: this.$store.getters.loggedUserAccount,
          Password: this.form_password.currentPassword,
          NewPassword: this.form_password.newPassword
        })
        .then(() => {
          console.log('OK')
          // this.$router.push({ name: 'Home' })
        })
        .catch(error => {
          console.log('ERROR: ' + error.response.data.Error)
          // this.error = err.response.data
        })
    }
  }
}
</script>
